<template>
  <ModalCABase
    v-if="isOpen"
    class="c-modal-ca"
    size="small"
    @close="closeModal"
  >
    <div slot="header" class="c-modal-ca__header">
      <img
        v-if="termoMonitorado"
        class="c-modal-ca__image"
        src="/assets/images/cta/d529d482cf75f6a0b6a55c51c66789de.png"
        width="182px"
      />
      <img
        v-else
        class="c-modal-ca__image"
        src="/assets/images/cta/830196f111ede05ae7ad.png"
        width="146px"
      />
      <div class="c-modal-ca__title">
        {{ title }}
      </div>
    </div>
    <div slot="content" class="c-modal-ca__content">
      <p>{{ content }}</p>

      <div
        class="c-modal-ca__features"
        :class="
          (processo || (pessoa && termoMonitorado)) &&
          'c-modal-ca__features--maior'
        "
      >
        <div class="c-modal-ca__feature c-modal-ca__feature--cinza">
          <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#EEBD65" />
            <path
              d="M6.5 11.3l4 4.4 7-7.4"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span v-if="cadastrado && pessoa && termoMonitorado"
            >Resultados ilimitados dos monitoramentos</span
          >
          <span v-else-if="pessoa">Busca automática em todo o Brasil</span>
          <span v-else-if="termoMonitorado && processo"
            >Acesso aos documentos do processo</span
          >
          <span v-else-if="processo">Atualizações em seu celular e e-mail</span>
        </div>
        <div class="c-modal-ca__feature c-modal-ca__feature--amarelo">
          <svg
            width="24"
            height="24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#EEBD65" />
            <path
              d="M6.5 11.3l4 4.4 7-7.4"
              stroke="#fff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span v-if="cadastrado && pessoa && termoMonitorado"
            >Atualização diária dos processos</span
          >
          <span v-else-if="pessoa">Acompanhamento processual incluso</span>
          <span v-else-if="termoMonitorado && processo"
            >Atualizações diárias do processo</span
          >
          <span v-else-if="processo">Acompanhamento automático e grátis</span>
        </div>
      </div>
      <p v-if="!cadastrado">
        Cadastre-se para testar <strong>gratuitamente</strong>.
      </p>
    </div>
    <div slot="footer" class="c-modal-ca__footer">
      <a
        rel="nofollow"
        :href="href"
        class="c-button c-button--secondary c-button--center"
      >
        <span class="label" style="display: block">
          {{ labelBotaoCTA }}
        </span>
      </a>
    </div>
  </ModalCABase>
</template>

<script>
import { url } from "../../utils/url";
import TESTES from "../../defaults/ab/testes";
import TesteAB from "../TesteAB";
import ModalCABase from "./ModalCABase";
export default {
  components: {
    TesteAB,
    ModalCABase,
  },
  props: {
    cadastrado: {
      default: false,
      type: Boolean,
    },
    processo: {
      default: false,
      type: Boolean,
    },
    assinante: {
      default: false,
      type: Boolean,
    },
    pessoa: {
      default: false,
      type: Boolean,
    },
    nome: {
      default: "maria",
      type: String,
    },
    href: {
      default: "",
      type: String,
    },
    termoMonitorado: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    title() {
      let title = "Não perca nenhum prazo deste processo!";

      if (this.pessoa && !this.cadastrado) {
        title = `Não perca informações importantes da justiça sobre ${this.nome}!`;
      } else if (this.cadastrado && this.pessoa && !this.termoMonitorado) {
        title = `Não perca informações importantes da justiça sobre ${this.nome}!`;
      } else if (this.cadastrado && this.pessoa && this.termoMonitorado) {
        title = `Já estamos monitorando as informações jurídicas de ${this.nome}!`;
      }
      if (this.cadastrado && this.processo && this.termoMonitorado) {
        title = "Já estamos monitorando esse processo para você!";
      } else if (this.cadastrado && this.processo && this.termoMonitorado) {
        title =
          "Pare de perder as movimentações dos processos! Tenha resultados ilimitados!";
      }

      return title;
    },
    content() {
      let content =
        "O assistente jurídico do Escavador acompanha o processo nos Diários Oficiais e sistemas de Tribunais.";

      if (this.pessoa && !this.cadastrado) {
        content =
          "O assistente jurídico do Escavador monitora nomes nos Diários Oficiais e envia todos os resultados para você.";
      } else if (this.cadastrado && this.pessoa && !this.termoMonitorado) {
        content =
          "O assistente jurídico do Escavador acompanha os processos nos Diários Oficiais e sistemas de Tribunais.";
      } else if (this.cadastrado && this.termoMonitorado) {
        content =
          "Agora só falta assinar um dos planos disponíveis para ter acesso a funcionalidades exclusivas do Escavador.";
      }

      return content;
    },
    testeAB() {
      return TESTES.MODAIS_PAGINAS_PUBLICAS;
    },
    labelBotaoCTA() {
      let label = "Monitorar nome";
      if (this.processo) {
        label = "Monitorar processo";
      }

      if (!this.cadastrado && this.pessoa) {
        label = "Cadastrar e Monitorar";
      } else if (!this.cadastrado && this.processo) {
        label = "Cadastrar e Monitorar processo";
      }

      if (this.termoMonitorado) {
        label = "Conhecer os planos";
      }

      return label;
    },
    pagina() {
      return this.pessoa ? "pessoa" : "processo";
    },
  },
  mounted() {
    // Sugiro que coloque o nome do modal para não conflitar com outros que
    // possam existir
    EventBus.$on("abrir-modal-campanha", this.openModal);
  },
  methods: {
    url(path = "") {
      return url(path);
    },
    openModal() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="stylus">
.c-modal-ca
  &__title
    font-size 24px
    font-weight 700
    line-height 1.4
    margin 12px auto 16px
  &__image
    max-width none!important
  &__content
    font-size 16px
  &__content
    margin-bottom 32px
    line-height 1.4

  &__features
    display flex
    justify-content center
    margin-bottom 24px
  &__features--maior
    flex-direction row-reverse
  &__features--maior
  &__features--maior &__feature--cinza
    margin-right 0
  &__features--maior &__feature--amarelo
    margin-right 8px
  &__features--maior &__feature
    max-width 215px
    padding 8px 12px
  &__feature
    border 1px solid
    padding 8px
    border-radius 8px
    max-width 180px
    font-size 13px
    line-height 1.4
    font-weight 500
    display flex
    align-items center
    text-align left
    & > svg
      flex-shrink 0
      margin-right 8px
  &__feature--cinza
    border-color #F4D69F
    background #FEFCF7
    margin-right 8px
  &__feature--amarelo
    border-color #F4D69F
    background #FEFCF7
    margin-left 8px

  &__footer
    display flex
    justify-content center
  &__header,
  &__content,
  &__footer
    max-width 500px
    text-align center
    width 100%
  @media (max-width 575px)
    &__features
      flex-direction column
      align-items center
    &__feature
      font-size 12px
    &__feature--cinza
      margin 0
    &__features--maior &__feature--amarelo
      margin-right 0
    &__feature--amarelo
      margin 12px 0 0
    & .Modal__content
      font-size 14px
    & .Modal__dialog
      padding 16px 24px
      align-items center
      justify-content center
    &__title
      font-size 20px
    &__image
      max-width 120px!important
    &__content
      font-size 14px
      margin-bottom 16px
    &__content > p:last-child
      font-size 15px
    &__header,
    &__content,
    &__footer
      max-width none
  @media (max-width 320px)
    &__image
      display none
</style>
